<template>
    <section>
        <div class="row">
            <div class="col-12">
                <supplier-list></supplier-list>
            </div>
        </div>
    </section>
</template>

<script>
import SupplierList from '@/components/supplier/List';

export default {
    components: {
        SupplierList
    }
}
</script>